import React from 'react';
import {useStore} from '@/app/providers/StoreProvider';
import {observer} from 'mobx-react-lite';

import {Loading} from '@/shared/ui/Loading';
import {Hud} from '@/entities/game/ui/Hud';
import {StageContainer} from '@/entities/game/ui/StageContainer';
import {Indicators} from '@/entities/game/ui/Indicators';
import {Buttons} from '@/entities/game/ui/Buttons';
import {Cursor} from '@/entities/game/ui/Cursor';
import {Pause} from '@/entities/game/ui/Pause';
import {Effects} from "@/entities/game/ui/Effects";
// import { MyTimer } from '@/shared/ui/MyTimer';


export const GamePage = observer(() => {
    const {userStore} = useStore();
    const {loadingUser} = userStore;
    if (loadingUser) return <Loading/>
    return (
        <div className='game-page'>
            <div className="container">
                <Hud/>
                <div className='relative'>
                    <StageContainer/>
                    <Pause/>
                    <Indicators/>
                    <Effects/>
                    <Cursor/>
                </div>
                <Buttons/>
                {/* <Flex className='tournament-timer' vertical align='center' justify='center' gap={5} ><p>Турнир завершится через: </p><MyTimer  date={'2025-11-20 19:00:00'}/></Flex> */}
            </div>
        </div>
    );
});
